// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__31n8M","modalForm":"UpgradeEpcsModal_modalForm__3GRlR","modalFooter":"UpgradeEpcsModal_modalFooter__2OHUf"};